module.exports = __webpack_public_path__ + "58b95e580.png";